import React from 'react'
import {
  Auth0Provider as RealAuth0Provider,
  useAuth0 as useRealAuth0,
  type Auth0ProviderOptions,
  type User,
} from '@auth0/auth0-react'

type Auth0ContextValue = ReturnType<typeof useRealAuth0>

export const Auth0Provider: React.FC<
  React.PropsWithChildren<Auth0ProviderOptions>
> = ({ children, ...props }) => {
  return <RealAuth0Provider {...props}>{children}</RealAuth0Provider>
}

export function useAuth0(): Auth0ContextValue {
  return useRealAuth0()
}

export type { User }
